import { v4 as uuid } from 'uuid'

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
    {
        _id: uuid(),
        title: 'Meek Slasher Skateboard Deck',
        desc: '9.23in x 31.67in Meek Slasher Santa Cruz Skateboard Deck',
        price: 5000,
        categoryName: 'skateboards',
        discountPrice: 4000,
        brand: 'santa cruz',
        totalRating: 565,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/santa_cruz_skateboard_1_wuvfow.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Japanese Morph Skateboard Deck',
        desc: '8.0in x 31.6in Japanese Morph Dot VX Everslick Santa Cruz Skateboard Deck',
        price: 5600,
        categoryName: 'skateboards',
        discountPrice: 4760,
        brand: 'santa cruz',
        totalRating: 535,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989363/blinder-ecom/santa_cruz_skateboard_2_gm6kos.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Kendall Skateboard Deck',
        desc: '10.0in x 29.7in Kendall End of the World Reissue Santa Cruz Skateboard Deck',
        price: 5056,
        categoryName: 'skateboards',
        discountPrice: 4550,
        brand: 'santa cruz',
        totalRating: 435,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/santa_cruz_skateboard_3_jqio3h.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Knox Punk Skateboard Deck',
        desc: '9.89in x 31.75in Knox Punk Reissue Santa Cruz Skateboard Deck',
        price: 6574,
        categoryName: 'skateboards',
        discountPrice: 4780,
        brand: 'santa cruz',
        totalRating: 235,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989363/blinder-ecom/santa_cruz_skateboard_4_mgaej2.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Gartland Lava Lamp Skateboard Deck',
        desc: '8.28in x 31.83in Gartland Lava Lamp Santa Cruz Skateboard Deck',
        price: 6774,
        categoryName: 'skateboards',
        discountPrice: 5680,
        brand: 'santa cruz',
        totalRating: 345,
        totalStars: 3,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/santa_cruz_skateboard_5_iqmuhg.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Gartland Lava Lamp Skateboard Deck',
        desc: '8.28in x 31.83in Gartland Lava Lamp Santa Cruz Skateboard Deck',
        price: 7774,
        categoryName: 'skateboards',
        discountPrice: 6780,
        brand: 'santa cruz',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/santa_cruz_skateboard_6_d4cjvo.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Thrasher Jacket Blue',
        desc: 'Heavyweight, 100% cotton t-shirt features our Outlined Rainbow Mag logo.',
        price: 3774,
        categoryName: 'jackets',
        discountPrice: 2340,
        brand: 'thrasher',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/thrasher_jacket_1_inbvte.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Vice Logo Hood (Black)',
        desc: 'Heavyweight, 90% cotton 10% polyester hooded sweatshirt featuring the hard-hitting Vice logo.',
        price: 3574,
        categoryName: 'jackets',
        discountPrice: 2340,
        brand: 'thrasher',
        totalRating: 135,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/thrasher_jacket_2_dji5du.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Future Logo Hood (Royal)',
        desc: 'Midweight, 50% cotton 50% polyester hooded sweatshirt featuring the brand new Future logo',
        price: 6574,
        categoryName: 'jackets',
        discountPrice: 5640,
        brand: 'thrasher',
        totalRating: 23,
        totalStars: 2,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/thrasher_jacket_3_lllzbo.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Godzilla Burst Crewneck',
        desc: 'Heavyweight, 90% cotton 10% polyester crewneck sweatshirt featuring a new twist on the Godzilla logo.',
        price: 6774,
        categoryName: 'jackets',
        discountPrice: 5640,
        brand: 'thrasher',
        totalRating: 673,
        totalStars: 3,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/thrasher_jacket_4_qaqgp2.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Low Low Logo T-shirt (Maroon)',
        desc: 'Heavyweight, 100% pre-shrunk cotton T-shirt featuring the one-of-kind Low Low logo.',
        price: 7774,
        categoryName: 'jackets',
        discountPrice: 6640,
        brand: 'thrasher',
        totalRating: 573,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/thrasher_jacket_5_psx5dx.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Outlined Hood (Black/Orange)',
        desc: 'Heavyweight, 90% cotton 10% polyester hooded sweatshirt features the Outlined Thrasher logo.',
        price: 7574,
        categoryName: 'jackets',
        discountPrice: 6540,
        brand: 'thrasher',
        totalRating: 553,
        totalStars: 1,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/thrasher_jacket_6_ikae5n.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'Vice Logo T-shirt (Navy)',
        desc: 'Heavyweight, 100% pre-shrunk cotton T-shirt featuring the hard-hitting Vice logo',
        price: 8574,
        categoryName: 'jackets',
        discountPrice: 7540,
        brand: 'thrasher',
        totalRating: 583,
        totalStars: 1,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989366/blinder-ecom/thrasher_jacket_7_gpj8nl.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 1',
        desc: 'Urban Monkey Snapback',
        price: 3574,
        categoryName: 'caps',
        discountPrice: 2540,
        brand: 'urban monkey',
        totalRating: 543,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989366/blinder-ecom/urban_monkey_cap_1_oyzqm4.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 2',
        desc: 'Urban Monkey Snapback',
        price: 5574,
        categoryName: 'caps',
        discountPrice: 4540,
        brand: 'urban monkey',
        totalRating: 643,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/urban_monkey_cap_2_qfsxzd.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 3',
        desc: 'Urban Monkey Snapback',
        price: 4574,
        categoryName: 'caps',
        discountPrice: 3540,
        brand: 'urban monkey',
        totalRating: 673,
        totalStars: 3,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/urban_monkey_cap_3_jhdlxf.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 4',
        desc: 'Urban Monkey Snapback',
        price: 6574,
        categoryName: 'caps',
        discountPrice: 5540,
        brand: 'urban monkey',
        totalRating: 373,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/urban_monkey_cap_4_abprm3.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 5',
        desc: 'Urban Monkey Snapback',
        price: 4574,
        categoryName: 'caps',
        discountPrice: 3540,
        brand: 'urban monkey',
        totalRating: 373,
        totalStars: 3,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989364/blinder-ecom/urban_monkey_cap_5_f3aqr3.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 6',
        desc: 'Urban Monkey Snapback',
        price: 8574,
        categoryName: 'caps',
        discountPrice: 7540,
        brand: 'urban monkey',
        totalRating: 473,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/urban_monkey_cap_6_sugam7.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 7',
        desc: 'Urban Monkey Snapback',
        price: 8574,
        categoryName: 'caps',
        discountPrice: 7540,
        brand: 'urban monkey',
        totalRating: 673,
        totalStars: 2,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/urban_monkey_cap_7_j4syyn.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 8',
        desc: 'Urban Monkey Snapback',
        price: 9574,
        categoryName: 'caps',
        discountPrice: 8540,
        brand: 'urban monkey',
        totalRating: 673,
        totalStars: 2,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/urban_monkey_cap_8_cvs5b7.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 9',
        desc: 'Urban Monkey Snapback',
        price: 9574,
        categoryName: 'caps',
        discountPrice: 8590,
        brand: 'urban monkey',
        totalRating: 673,
        totalStars: 2,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989365/blinder-ecom/urban_monkey_cap_9_dxgsur.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 10',
        desc: 'Urban Monkey Snapback',
        price: 7574,
        categoryName: 'caps',
        discountPrice: 6590,
        brand: 'urban monkey',
        totalRating: 273,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989366/blinder-ecom/urban_monkey_cap_10_alrlda.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM CAP 11',
        desc: 'Urban Monkey Snapback',
        price: 10574,
        categoryName: 'caps',
        discountPrice: 10090,
        brand: 'urban monkey',
        totalRating: 273,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989366/blinder-ecom/urban_monkey_cap_11_bkevbh.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM jacket 1',
        desc: 'Urban Monkey Jacket',
        price: 14574,
        categoryName: 'jackets',
        discountPrice: 13090,
        brand: 'urban monkey',
        totalRating: 273,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989366/blinder-ecom/urban_monkey_jacket_1_u4obwh.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM jacket 2',
        desc: 'Urban Monkey Jacket',
        price: 16574,
        categoryName: 'jackets',
        discountPrice: 15090,
        brand: 'urban monkey',
        totalRating: 293,
        totalStars: 1,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989366/blinder-ecom/urban_monkey_jacket_2_jahrfx.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM jacket 3',
        desc: 'Urban Monkey Jacket',
        price: 14574,
        categoryName: 'jackets',
        discountPrice: 13090,
        brand: 'urban monkey',
        totalRating: 273,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989366/blinder-ecom/urban_monkey_jacket_3_midmph.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM jacket 4',
        desc: 'Urban Monkey Jacket',
        price: 17574,
        categoryName: 'jackets',
        discountPrice: 16090,
        brand: 'urban monkey',
        totalRating: 573,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989367/blinder-ecom/urban_monkey_jacket_4_wqb575.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM jacket 5',
        desc: 'Urban Monkey Jacket',
        price: 18574,
        categoryName: 'jackets',
        discountPrice: 18090,
        brand: 'urban monkey',
        totalRating: 473,
        totalStars: 1,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989367/blinder-ecom/urban_monkey_jacket_5_pxpeap.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM jacket 6',
        desc: 'Urban Monkey Jacket',
        price: 19574,
        categoryName: 'jackets',
        discountPrice: 19090,
        brand: 'urban monkey',
        totalRating: 473,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989367/blinder-ecom/urban_monkey_jacket_6_yy4nmc.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM jacket 7',
        desc: 'Urban Monkey Jacket',
        price: 19574,
        categoryName: 'jackets',
        discountPrice: 19090,
        brand: 'urban monkey',
        totalRating: 473,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_jacket_7_oujosk.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM jacket 8',
        desc: 'Urban Monkey Jacket',
        price: 16574,
        categoryName: 'jackets',
        discountPrice: 16090,
        brand: 'urban monkey',
        totalRating: 473,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989367/blinder-ecom/urban_monkey_jacket_8_ocssg3.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Mask 1',
        desc: 'Urban Monkey Mask',
        price: 574,
        categoryName: 'accessories',
        discountPrice: 490,
        brand: 'urban monkey',
        totalRating: 476,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989367/blinder-ecom/urban_monkey_mask_1_gjn7uh.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Mask 2',
        desc: 'Urban Monkey Mask',
        price: 674,
        categoryName: 'accessories',
        discountPrice: 490,
        brand: 'urban monkey',
        totalRating: 376,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989367/blinder-ecom/urban_monkey_mask_2_zgfu8x.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Mask 3',
        desc: 'Urban Monkey Mask',
        price: 674,
        categoryName: 'accessories',
        discountPrice: 590,
        brand: 'urban monkey',
        totalRating: 476,
        totalStars: 2,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_mask_3_iiaibx.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Mask 4',
        desc: 'Urban Monkey Mask',
        price: 674,
        categoryName: 'accessories',
        discountPrice: 590,
        brand: 'urban monkey',
        totalRating: 476,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_mask_4_djdzdm.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Mask 5',
        desc: 'Urban Monkey Mask',
        price: 674,
        categoryName: 'accessories',
        discountPrice: 590,
        brand: 'urban monkey',
        totalRating: 476,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_mask_5_lvc6gr.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Mask 6',
        desc: 'Urban Monkey Mask',
        price: 674,
        categoryName: 'accessories',
        discountPrice: 590,
        brand: 'urban monkey',
        totalRating: 476,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_mask_6_yuf8kq.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Wallet 2',
        desc: 'Urban Monkey wallet',
        price: 1174,
        categoryName: 'accessories',
        discountPrice: 990,
        brand: 'urban monkey',
        totalRating: 476,
        totalStars: 4,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_wallet_1_azqbuw.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Skateboard Deck 1',
        desc: '8.28in x 31.83in Gartland Lava Lamp Urban Monkey Skateboard Deck',
        price: 11774,
        categoryName: 'skateboards',
        discountPrice: 9780,
        brand: 'urban monkey',
        totalRating: 325,
        totalStars: 2,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_skateboard_1_anpokl.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Skateboard Deck 2',
        desc: '8.28in x 31.83in Gartland Lava Lamp Urban Monkey Skateboard Deck',
        price: 12774,
        categoryName: 'skateboards',
        discountPrice: 11780,
        brand: 'urban monkey',
        totalRating: 325,
        totalStars: 2,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_skateboard_2_qy2lx0.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'UM Skateboard Deck 3',
        desc: '8.28in x 31.83in Gartland Lava Lamp Urban Monkey Skateboard Deck',
        price: 13774,
        categoryName: 'skateboards',
        discountPrice: 12780,
        brand: 'urban monkey',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/urban_monkey_skateboard_3_ameacd.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'vans jacket 1',
        desc: 'Vans Jacket',
        price: 13774,
        categoryName: 'jackets',
        discountPrice: 12780,
        brand: 'vans',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/vans_jacket_1_ziwyh4.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'vans jacket 2',
        desc: 'Vans Jacket',
        price: 13774,
        categoryName: 'jackets',
        discountPrice: 12780,
        brand: 'vans',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989368/blinder-ecom/vans_jacket_2_zssjpw.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'vans jacket 3',
        desc: 'Vans Jacket',
        price: 13774,
        categoryName: 'jackets',
        discountPrice: 12780,
        brand: 'vans',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989369/blinder-ecom/vans_jacket_3_li67ag.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'vans jacket 4',
        desc: 'Vans Jacket',
        price: 13774,
        categoryName: 'jackets',
        discountPrice: 12780,
        brand: 'vans',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989369/blinder-ecom/vans_jacket_4_zlcjrl.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'vans jacket 5',
        desc: 'Vans Jacket',
        price: 13774,
        categoryName: 'jackets',
        discountPrice: 12780,
        brand: 'vans',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989369/blinder-ecom/vans_jacket_5_oznmpo.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'vans jacket 6',
        desc: 'Vans Jacket',
        price: 13774,
        categoryName: 'jackets',
        discountPrice: 12780,
        brand: 'vans',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989369/blinder-ecom/vans_jacket_6_holorh.jpg',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
    {
        _id: uuid(),
        title: 'vans jacket 7',
        desc: 'Vans Jacket',
        price: 13774,
        categoryName: 'jackets',
        discountPrice: 12780,
        brand: 'vans',
        totalRating: 325,
        totalStars: 5,
        img: 'https://res.cloudinary.com/supertramp69420/image/upload/v1648989369/blinder-ecom/vans_jacket_7_mdj4dx.webp',
        qty: 1,
        offers: {
            fastDelivery: true,
            freeDelivery: false,
            newArrival: false,
            inStock: true,
            bestSeller: false,
            newArrival: true,
        },
    },
]
